import { TableColumn } from "../types/financesTableComponentTypes";

/**
 * Generates the correct Formik field name for a given column in a Formik field array.
 *
 * @param column - The column definition from `TableColumn`
 * @param index - The row index in the Formik field array
 * @param fieldArrayName - The root name of the Formik field array
 * @param singular - If `true`, removes index-based array notation
 * @param referenceSelf - If `true`, returns only the base field name without dot notation
 * @param isThresholdPercentMode -
 * @param isAwardPercentMode -
 * @returns The correctly formatted field name for Formik usage
 */
export const getFieldArrayName = (
  column: TableColumn,
  index: number,
  fieldArrayName: string,
  singular: boolean = false,
  referenceSelf: boolean = false,
  isThresholdPercentMode = false,
  isAwardPercentMode = false
): string => {
  const baseFieldName = `${fieldArrayName}${singular ? "" : `[${index}]`}`;

  if (referenceSelf) {
    return baseFieldName;
  }

  if (typeof column.fieldname === "object") {
    return isThresholdPercentMode
      ? `${baseFieldName}.${column.fieldname.percent}`
      : `${baseFieldName}.${column.fieldname.amount}`;
  }

  return `${baseFieldName}.${column.fieldname}`;
};
